// extracted by mini-css-extract-plugin
module.exports = {"button":"_14f8823"};